@if (specificConfig.showLabel) {
	<h6>{{ specificConfig.label }}</h6>
}
@for (radio of specificConfig.options; track radio.primaryValue) {
	<div class="form-check form-check-inline">
		<input
			(change)="onRadioSelect($event)"
			name="gruppo{{ specificConfig.id }}"
			type="radio"
			id="radio{{ specificConfig.id }}{{ $index }}"
			[value]="radio.primaryValue"
			[attr.seondaryValue]="radio.secondaryValue"
			[attr.checked]="specificConfig.defaultValues.includes(radio.primaryValue) ? true : null" />
		<label for="radio{{ specificConfig.id }}{{ $index }}">{{ radio.label }}</label>
	</div>
}
